export default{
    usTitle:"Contact us",
    usH4:"Request a call",
    usSpan:"Give us some info so the right person can get back to you.",
    first:'Name',
    last: 'Last name',
    email:"Email",
    phone:"Phone number",
    company:"Company name",
    message:"Message",
    country:"Country/Region",
    state:"State",
    city:"City",
    submit:"Submit",
    h4:"Come to see us",
    p1:"Address：",
    // p1:"Asia, Indonesia:",
    // p2:"Asia, Singapore:",
    hint:"Required field",
    emailHint:"Formal error",
    dialogTitle:'submit successfully',
    dislogP:'Wait patiently,We will contact you as soon as possible.',
    

}